import React from 'react';

const ZoomMinus = ({ stroke }) => {
     return(
               <svg viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0" y="45" width="100" height="10" stroke={stroke} />
               </svg>
          )
}

export default ZoomMinus;


